<template>
    <div class="col-sm-12 nopads">
        <!-- Equipment report -->

        <form class="col-12 editor-form px-1" @submit.prevent="submitEquipmentReport(index)">
            <!-- Equipment Title and Description -->
            <div class="col-12 mb-2">
                <h4 class="editor-header" style="font-size: 1.2em">
                    {{ getEquipmentName() }}
                </h4>
                <div>
                    {{ equipment.description }}
                </div>
            </div>

            <!-- Form Content -->
            <div class="row">
                <div class="col-sm-7">
                    <div class="col-12 nopads form-data">
                        <!-- Result Select -->
                        <span class="span-title">
                          {{ $t('equipment_report.result') }}
                        </span>
                        <div class="form-group title">
                            <select
                                id="equipment_result"
                                v-model="equipmentReport.result"
                                class="form-control form-control-sm sm-3"
                            >
                                <option :value="null">
                                    {{ $t('equipment_report.select_equipment_condition') }}
                                </option>
                                <option
                                    v-for="result in options"
                                    :key="result.id"
                                    :value="result"
                                >
                                    {{ getEquipmentResult(result) }}
                                </option>
                            </select>
                        </div>

                        <!-- Info Input -->
                        <span class="span-title">
                          {{ $t('equipment_report.info') }}
                        </span>
                        <div class="form-group title">
                            <textarea
                                id="note"
                                v-model="equipmentReport.info"
                                class="form-control"
                                rows="3"
                            ></textarea>
                        </div>

                        <!-- Value Input -->
                        <span class="span-title">
                          {{ $t('equipment_report.value') }}
                        </span>
                        <div class="form-group title">
                            <input
                                id="value"
                                v-model="equipmentReport.value"
                                type="text"
                                class="form-control form-control-sm"
                            />
                        </div>

                        <!-- Photo Upload -->
                        <span class="span-title">
                          {{ $t('equipment.photo') }}
                        </span>

                        <!-- Hidden file input -->
                        <input
                            type="file"
                            class="d-none"
                            accept="image/jpeg, image/jpg, image/png"
                            @change="onFileChange"
                            ref="fileInput"
                        />

                        <div class="d-flex justify-content-between align-items-center">
                            <span class="flex-grow-1">{{ selectedFile ? selectedFile.name :  $t('equipment.photo_placeholder') }}</span>
                            <button
                                type="button"
                                class="btn btn-outline-primary btn-sm form-button me-2"
                                @click="triggerFileInput"
                            >
                                {{ $t('common.add_photo') }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Image Container -->
                <div class="col-sm-5 img-container">
                    <ImageView v-if="getPhotoUrl(equipmentReport.equipment)" :url="getPhotoUrl(equipmentReport.equipment)"/>
                    <div v-else class="img-placeholder text-center">
                        {{ $t('equipment.no_photo') }}
                    </div>
                </div>

                <!-- Button Group -->
                <div class="col-12 text-end my-2">
                    <button type="submit" class="btn btn-success form-button" :disabled="loading || equipmentReport.result == null">
                      {{ $t('common.save') }}
                    </button>
                </div>
                <hr/>
            </div>
        </form>

        <!-- Loading Spinner -->
        <div v-if="loading" id="loader" class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {areaReportHelper, results} from '../../mixins/AreaReportMixin.js'
import {areaHelper} from '../../mixins/AreaMixin.js'
import {attachmentHelper} from '../../mixins/AttachmentMixin.js'
import ImageView from '../../view/ImageView'
import {inject} from "vue";

export default {
    name: 'AreaEquipmentReportEditor',
    components: {ImageView},
    mixins: [areaHelper, areaReportHelper, results, restApi, attachmentHelper],
    props: {
        equipment: {
            type: Object,
            required: true
        },
        reportId: {
            type: Number,
            required: true
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            equipmentReport: null,
            equipmentResult: null,
            selectedFile: null,
            options: Object.values(results)
        }
    },
    created: function () {
            this.equipmentReport = this.newAreaEquipmentReport()
            this.equipmentReport.equipment = this.equipment
    },
    methods: {
        onFileChange(event) {
            const file = event.target.files[0]
            if (file) {
                this.selectedFile = file
            }
        },

        triggerFileInput() {
            // Trigger the file input to open the file dialog
            this.$nextTick(() => {
                const input = this.$refs.fileInput
                if (input) {
                    input.click()
                }
            })
        },

        checkInspected: function (equipment, equipmentInspectionResults) {
            var isInspected = false
            if (equipmentInspectionResults) {
                equipmentInspectionResults.forEach(insResult => {
                    if (insResult.equipment.id === equipment.id) {
                        isInspected = true
                    }
                })
            }
            return isInspected
        },
        getEquipmentName: function () {
            return this.equipment.manufacturer ? this.equipment.name + ' - ' + this.equipment.manufacturer : this.equipment.name
        },

        checkValues: function () {
            if (this.equipmentResult == null) {
                this.showAlert(this.$t('equipment_report.err_result'))
                return false
            }
            return true
        },

        submitEquipmentReport: function () {
            this.loading = true
            let formData = new FormData()
            if (this.selectedFile) {
                formData.append('photos[]', this.selectedFile)
            }
            this.restPostWithFile(this.equipInsResultUrl + this.reportId, this.equipmentReport, formData, this.success, this.fail)
        },

        success: function (responseData) {
            this.loading = false
            this.$emit('resultUploaded', this.equipmentReport)
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_add_failed'))
            this.loading = false
        },
    }
}
</script>

<style scoped>
.editor-form:not(:first-child) {
    margin-top: 10px;
}
</style>
